import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Row, Glyphicon, Button, Alert } from 'react-bootstrap';
import moment from 'moment';

import FormSectionStatus from './FormSectionStatus';
import { updateCertificate  } from '../actions';
import { certificateTypes, statusTypes } from '../config/constants';
import { CertificateValidation } from "../validation/professionalValidation";

class Certificate extends Component {
  constructor(props){
    super(props);
    this.handleCertificateChanges = this.handleCertificateChanges.bind(this);
    this.handleCertificateTypeChange = this.handleCertificateTypeChange.bind(this);
    this.handleCertificateNumberChange = this.handleCertificateNumberChange.bind(this);
    this.handleCertificateExpirationDateChange = this.handleCertificateExpirationDateChange.bind(this);
    this.handleRemoveCertificate = this.handleRemoveCertificate.bind(this);
  }

  handleCertificateTypeChange(e){
    const updates = { type: e.target.value };
    this.handleCertificateChanges(updates);
  }

  handleCertificateNumberChange(e){
    const updates = { number: e.target.value };
    this.handleCertificateChanges(updates);
  }

  handleCertificateExpirationDateChange(e){
    const updates = { expirationDate: e.target.value };
    this.handleCertificateChanges(updates);
  }

  handleCertificateChanges(updates){
    const {dispatch, id} = this.props;
    dispatch(updateCertificate(id, updates));
  }

  handleRemoveCertificate(e){
    e.preventDefault();
    this.props.onRemoveCertificate(this.props.id);
  }

  render() {
    const { id, type, number, expirationDate, applicationEndDate } = this.props;
    const space = ' ';
    const validationState = new CertificateValidation().getValidationStatus(this.props);
    const expired = moment(applicationEndDate).isAfter(moment(expirationDate)) && typeof expirationDate !== 'undefined';

    const getTypeOptions = () => {
      return Object.keys(certificateTypes).map((type) => {
        return (
          <option key={type} value={type}>{certificateTypes[type]}</option>
        )
      });
    };

    const getSectionStatus = () => {
      return validationState.section.status === statusTypes.SUCCESS ? null : <FormSectionStatus {...validationState.section}/>;
    };

    return (
      <React.Fragment>
        <Row>
          <Col md={4}>
            <FormGroup
              controlId={`certificate-${id}-type`}
            >
              <ControlLabel>
                Certificate Type
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={type}
                onChange={this.handleCertificateTypeChange}>
                <option value="">Select</option>
                { getTypeOptions() }
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup
              controlId={`certificate-${id}-number`}
            >
              <ControlLabel>
                Certificate #
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={number}
                placeholder="Certificate #"
                onChange={this.handleCertificateNumberChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId={`certificate-${id}-expirationDate`}
            >
              <ControlLabel>
                Expiration Date
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="date"
                value={expirationDate}
                placeholder="Enter Expiration Date"
                onChange={this.handleCertificateExpirationDateChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup
              controlId={`certificate-${id}-remove`}
            >
              <ControlLabel>
                Remove
              </ControlLabel>
              <Button bsStyle="danger"
                      onClick={this.handleRemoveCertificate}
                      style={{width: '100%'}}>
                <Glyphicon glyph="trash"/>
                {space}
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <div className="clearfix"/>
        {expired &&
        <Alert bsStyle='warning'>
          Certificate is or will be expired before the end of the application period. You WILL NOT receive points for an
          expired certificate but you may receive points for work experience accrued with a valid certificate.
        </Alert>
        }
        {getSectionStatus()}
      </React.Fragment>
    );
  };
}

export default Certificate;